import React from 'react';
import Logo from '../../src/assets/img/logo/Logo_final_.png';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { language } = useLanguage();
  const today = new Date();

  return (
    <footer>
      <div className="row my-bg-black">
        <div className="col-4">
          <img
            id="jambotronImg"
            src={Logo}
            alt="ACE"
          />
        </div>

        <div
          className="col-8 py-5"
          id="footer-text"
        >
          <h6 className="bold">
            ACE - Actions Culture of Excellence
            {' '}
            (actions-culture-of-excellence.org)
          </h6>

          <hr />

          <p>
            {language === 'fr'
              ? "ACE est une association à but non lucratif créée en août 2012 pour promouvoir une culture de l’excellence, le développement des compétences, l’entrepreneuriat, l’innovation et le développement inclusif. À travers ses programmes et ses partenariats, ACE accompagne les individus, les communautés et les entreprises dans le développement de leurs capacités et la création d’opportunités économiques et sociales durables."
              : 'ACE is a nonprofit association established in August 2012 to promote a culture of excellence, skills development, entrepreneurship, innovation, and inclusive development. Through its programmes and partnerships, ACE supports individuals, communities, and enterprises in developing their capacities and creating sustainable economic and social opportunities.'}
          </p>

          <p>
            {language === 'fr'
              ? 'Pour toute demande de partenariat ou d’information : '
              : 'For partnership enquiries or further information: '}

            <strong>
              @actions-culture-of-excellence.org
            </strong>
          </p>

          <p>
            Copyright &copy; {today.getFullYear()} ACE
          </p>

          <br />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
